package one.healthium.profile.ui.profile.components

import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.fadeIn
import androidx.compose.animation.fadeOut
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.offset
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.MediumTopAppBar
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBarDefaults
import androidx.compose.material3.TopAppBarScrollBehavior
import androidx.compose.material3.TopAppBarState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import ifaandroid.feature.profile.profile_ui.generated.resources.Res
import ifaandroid.feature.profile.profile_ui.generated.resources.ic_settings_30
import loco.ME_SCREEN_TITLE_FORMAT
import one.healthium.profile.ui.avatar.UserAvatar
import one.healthium.profile.ui.profile.ProfileUiState
import one.healthium.ui.compose.components.AppTopBar
import one.healthium.ui.compose.components.AppTopBarDefaults
import one.healthium.ui.compose.theme.AppTheme
import org.jetbrains.compose.resources.painterResource
import org.jetbrains.compose.resources.stringResource

private val UserAvatarOffset = 18.dp

@Composable
internal fun ProfileAppBar(
    profileState: ProfileUiState,
    topAppBarState: TopAppBarState,
    scrollBehavior: TopAppBarScrollBehavior,
    onSettingsClicked: () -> Unit,
) {
    val isExpanded by remember {
        derivedStateOf { topAppBarState.collapsedFraction == 0f }
    }

    Box {
        val appBarColor = AppTheme.appTopBarStyle.colors?.containerColor ?: AppTopBarDefaults.colors().containerColor
        MediumTopAppBar(
            title = { },
            colors = TopAppBarDefaults.topAppBarColors(
                containerColor = appBarColor,
                scrolledContainerColor = appBarColor,
            ),
            collapsedHeight = 46.dp, // height of regular appbar
            expandedHeight = 115.dp,
            scrollBehavior = scrollBehavior,
        )
        AppTopBar(
            title = {
                Text(stringResource(loco.Res.string.ME_SCREEN_TITLE_FORMAT, profileState.profile?.name.orEmpty()))
            },
            actions = {
                IconButton(onClick = onSettingsClicked) {
                    Icon(
                        painter = painterResource(Res.drawable.ic_settings_30),
                        tint = AppTheme.profileStyle.settingButtonTintOrDefault,
                        contentDescription = null,
                    )
                }
            }
        )
        AnimatedVisibility(
            modifier = Modifier
                .align(Alignment.BottomCenter)
                .offset(y = UserAvatarOffset),
            visible = isExpanded,
            enter = fadeIn(),
            exit = fadeOut(),
        ) {
            UserAvatar(size = 84.dp)
        }
    }
}